<template>
  <div class="home">
    <h1> Welcome to my App</h1>
    <p>Lorem ipsum, dolor sit amet consectetur adipisicing elit. Ut tempore tempora consectetur. Aliquid earum id architecto vero omnis? Voluptates repellat nisi aliquam soluta porro dicta tempora reiciendis, maiores odit? Quo repellendus tempora aspernatur, fugiat eius voluptate neque eos, sequi cum dolores, sint eaque dolorem assumenda velit. Eaque voluptate ipsum illum inventore autem vero quam, perspiciatis deleniti et, earum error, iure alias maiores eligendi maxime! Hic ipsam quasi eius omnis quos quaerat sit expedita eligendi aliquam vero, inventore doloribus eveniet sequi iusto possimus non distinctio necessitatibus in labore id aperiam iste nulla corporis consequatur. Iusto eum culpa, optio aperiam commodi odio!</p>
  </div>
</template>

<script>
// @ is an alias to /src 

export default {
  name: 'HomeView'
}
</script>
